/* شروط بيع قطع الوكالة (owner 3 Nov 2026 11:32: «زر موافقه وجنبه فيه تفاصيل .. هذه لتقلل الخطر مع الزبون حتى لايرفع بلاغ»).
   The cart's checkout buttons stay closed until the box of snippets/genuine-terms-consent.liquid is ticked; the consent goes on
   the order as the cart attribute «شروط قطع الوكالة» (with the time). One listener on the page, so a cart drawer drawn again
   after «add to cart» is covered too. */
(function () {
  if (window.sfGenuineTerms) return;
  window.sfGenuineTerms = true;
  var KEY = 'شروط قطع الوكالة';
  var GO = '[name="checkout"], .cart__dynamic-checkout-buttons, .additional-checkout-buttons, a[href*="/checkout"]';
  function scopeOf(el) {
    return (el && el.closest && el.closest('cart-drawer, .cart-drawer, #CartDrawer, form[action*="/cart"], .cart__footer, #MainContent')) || document;
  }
  function boxNear(el) {
    return scopeOf(el).querySelector('.genuine-terms__box') || document.querySelector('.genuine-terms__box');
  }
  function mark(box, missing) {
    var w = box && box.closest('.genuine-terms');
    if (!w) return;
    w.classList.toggle('is-missing', !!missing);
    w.classList.toggle('is-ok', !!box.checked);
    var h = w.querySelector('.genuine-terms__hint');
    if (h) h.hidden = !missing;
    if (missing && w.scrollIntoView) w.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function save(box) {
    var val = box.checked ? 'موافق ' + new Date().toISOString().slice(0, 16).replace('T', ' ') + ' UTC' : '';
    var w = box.closest('.genuine-terms');
    var hidden = w && w.querySelector('.genuine-terms__value');
    if (hidden) hidden.value = val;
    var attrs = {};
    attrs[KEY] = val;
    var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest && e.target.closest('.genuine-terms__box');
    if (!box) return;
    mark(box, false);
    save(box);
  });
  function stop(e, el) {
    var box = boxNear(el);
    if (!box || box.checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    mark(box, true);
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(GO);
    if (t) stop(e, t);
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') stop(e, s);
  }, true);
})();
